<template>
    <div class="container-fluid  pt-2">
        <div v-if="pageHasLoaded" class="pt-5">
            <div class="row">
                <div class="col-md-4 col-sm-4">
                    <div class="text-left py-1">
                        <h4 class="text-weight-900">Customers</h4>
                    </div>
                </div>
                <div class="col-md-8 col-sm-12">
                    <div class="text-right py-1">
                        <a v-b-modal="'import-customers-modal'" class="btn btn-sm btn-outline-primary">Import from file</a>
                        <a @click="addNewCustomerModal" class="btn btn-sm btn-outline-primary">Add a customer </a>

                                <a class="btn btn-outline-secondary btn-sm dropdown-toggle"  type="button" data-toggle="dropdown" aria-expanded="false">
                                More...
                                </a>
                                <div class="dropdown">
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#"  v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage customers')" @click="downloadCustomerFile">Download List </a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item"  v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage customers')" @click="openTextboxModal" href="#">Send SMS To All </a>
                                    <div class="dropdown-divider"></div>



                                </div>
                                </div>

                    </div>
                </div>
            </div>
            <div class="py-1">
                <div class="row">



                    <div class="col-md-4 col-sm-8">

                        <!-- <input type="text" class="form-control" v-model="searchCustomer" placeholder="Search Customer by phone,email or name"> -->
                        <div class="input-group mb-2 mr-sm-2">
                            <div class="input-group-prepend bg-light">
                            <div class="input-group-text"><i class="bi bi-search"></i></div>
                            </div>
                            <input type="text" class="form-control" v-model="searchCustomerQuery" id="inlineFormInputGroupUsername2" debounce="500" placeholder="Search Customer by phone,email or name">
                        </div>

                    </div>
                    <div class="col-md-8 col-sm-4">
                        <div class="py-2">
                            <h6 class="mt-2"><span class="border-dark border rounded py-1 px-2 "><span class="text-primary">
                            {{ totalCustomers }}
                        </span></span>&nbsp;Customers found</h6>
                        </div>

                    </div>
                </div>

            </div>
            <div style="margin-bottom: 5em;">
                <b-table
                    striped
                    hover
                    sticky-header="100vh"
                    :items="customerstable.items"
                    :fields="customerstable.fields"
                    sort-icon-left
                    responsive="sm"
                    @row-clicked="RowSelected">
                    <template #cell(index)="data">
                            <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                            <span>{{ data.index + 1 }}</span>
</template>

<template #cell(full_name)="data">
    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
    <p class="text-primary underline-primary">{{ data.item.full_name }}</p>
</template>
<template #cell(created_at)="data">
    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
    <p class="text-primary underline-primary">{{ formatDate(data.item.created_at,'DD-MMM-Y') }}</p>
</template>



            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalCustomers"
                :per-page="perPage"
                @input="getCustomers">
            </b-pagination>
            </div>



        <!--Page modals-->
        <!--<b-modal ref="productmodal" id="modal-center"  hide-footer hide-header static>-->
            <!--<div class="text-center">-->
                <!--<img :src=Selected_product.img />-->
                <!--<h2 class="text-weight-700">{{Selected_product.product}}</h2>-->
                <!--<hr/>-->
                <!--<form @submit="onSubmit" v-if="show">-->
                    <!--<b-form-group-->
                            <!--id="input-group-1"-->

                            <!--label-for="input-1"-->
                            <!--:description= "'Remaining units ' + Selected_product.remaining_units + ' ' + Selected_product.measuring_unit"-->
                    <!--&gt;-->
                        <!--<b-form-input-->
                                <!--id="input-1"-->
                                <!--v-model=restockform.quantity-->
                                <!--type="text"-->
                                <!--class="border"-->

                                <!--required-->
                        <!--&gt;</b-form-input>-->

                    <!--</b-form-group>-->
                    <!--<b-button type="submit" variant="primary" class="btn-block">Submit Stock ({{Selected_product.measuring_unit}})</b-button>-->

                <!--</form>-->
            <!--</div>-->
        <!--</b-modal>-->
        <b-modal ref="new-customers-modal" hide-footer hide-header static>

            <div class="container text-center">
                <div class="text-centre"><h2 class="font-weight-bold ">Add Customer</h2></div>

            </div>
            <div class="text-center" v-html="successMessage">{{successMessage}}</div>
            <div class="container py-3">
                <!-- Actual search box -->
                <form v-on:submit="NewCustomerInfo">
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom"  v-model="customerData.f_name" name="f_name" type="text" placeholder="First Name"/>
                            <!--<small class="text-danger">{{ errors.first('f_name') }}</small>-->

                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="customerData.l_name" name="l_name" type="text" placeholder="Last Name"/>
                            <!--<small class="text-danger">{{ errors.first('l_name') }}</small>-->
                        </div>
                    </div>
                    <div class="form-group py-1">

                        <input class="form-control border-bottom" name="c_email" v-model="customerData.c_email" type="email" placeholder="Email"/>


                    </div>
                    <div class="form-group">

                        <input class="form-control border-bottom"  v-model="customerData.phone_no" name="phone_no" type="text" placeholder="Phone Number"/>


                    </div>
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="customerData.h_no" name="h_no" type="text" placeholder="House Number"/>
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="customerData.apartment" name="apartment" type="text" placeholder="Apartment"/>
                        </div>
                    </div>
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="customerData.street" name="street" type="text" placeholder="Street"/>
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="customerData.town" name="town" type="text" placeholder="Town"/>
                        </div>
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-primary btn-block">Add Customer</button>
                    </div>
                </form>
            </div>



        </b-modal>



            <b-modal id="textmessage-modal" ref="textmessage_modal" hide-footer>
                <div class="text-center">
                    <h2>Send SMS to Customer</h2>
                </div>
                <form @submit.prevent="sendSMSToCustomer">
                    <div class="form-group">
                        <textarea class="form-control" v-model="smsForm.message" required>start typing</textarea>
                    </div>
                    <div class="my-2 form-group">
                        <button type="submit" class="btn btn-outline-primary"> Send SMS</button>
                    </div>
                </form>

            </b-modal>
            <b-modal ref="textBoxModal" hide-footer>
                <div v-if="userDetails.company.companysettings && userDetails.company.companysettings.sender_id">
                    <div class="text-center">
                    <h2>Send SMS to All Customers</h2>
                </div>
                <form @submit.prevent="sendSMSToAllCustomers">
                    <div class="form-group">
                        <textarea class="form-control" v-model="smsForm.message" required>start typing</textarea>
                    </div>
                    <div class="my-2 form-group">
                        <button type="submit" class="btn btn-outline-primary btn-block"> Send SMS</button>
                    </div>
                </form>
                </div>
                <div v-else>
                  <div class="text-center">
                    <h4>Talk to sales to enable this</h4>
                    <p><a class="btn btn-primary" href="https://wa.me/254725445898">Whatsapp Sales</a></p>
                </div>
                </div>


            </b-modal>
            <b-modal id="import-customers-modal" size="lg" ref="import_customers_modal_modal" hide-header hide-footer>
                <div v-if="!customerFileProcessing">
                    <div class="text-left py-3">

                 <h1>Import customers from CSV</h1>
                 <p class="py-3">A CSV (comma-separated values) file is a spreadsheet file that is used by Dukakit to import customer information into your business.</p>
             </div>
             <vue-dropzone ref="myVueDropzone" id="customdropzone" :options="dropzoneOptionsCustomer" :useCustomSlot="true"
                 v-on:vdropzone-success="uploadFileSuccess" v-on:vdropzone-error="uploadError"
                 v-on:vdropzone-removed-file="fileRemoved">
                 <div class="dropzone-custom-content">
                     <div class="text-center">
                         <p class="text-secondary"> <i class="fas fa-file-alt"></i></p>

                         <p><small class="dropzone-custom-title text-secondary py-2">Drag & Drop</small></p>

                         <a class="btn btn-outline-secondary" href="#">Choose File</a>

                         <p><small class="text-secondary">Max file size 10MB</small></p>
                     </div>
                 </div>
             </vue-dropzone>
             <p>
         <p class="py-2"> Need help creating your CSV file? <a data-toggle="collapse" href="#collapseCustomer" role="button" aria-expanded="false" aria-controls="collapseCustomer">
         View instructions
         </a> </p> </p>
             <div class="collapse" id="collapseCustomer">
             <div class="card card-body">
                 <div id="csv-instructions" style="">
                 <h2 class="wv-heading--subtitle">Customer CSV template file</h2>
                 <p ><a class="wv-text--link" href="https://dukakit-r2-bucket.dukakit.com/Dukakit_Customer_Import_List_Template%20-%20Sheet1.csv">Download and view our customer CSV template.</a> You can use this as a template for creating your CSV file.</p>

                 <div class="wv-divider--whitespace"></div>

                 <h2 class="wv-heading--subtitle">File format</h2>
                 <p >The first line of your customer CSV <strong>&nbsp must include all of the headers</strong>&nbsp  listed below, which are included in the <a class="wv-text--link" href="https://dukakit-r2-bucket.dukakit.com/Dukakit_Customer_Import_List_Template%20-%20Sheet1.csv">customer CSV template</a>.</p>
                 <div class="wv-box wv-box--large wv-box--gray">
                 <div class="wv-box__content">
                     <p ><i class="wv-icon--info"></i> <strong>&nbsp Reminder: </strong>&nbsp  All CSV file headers are case-sensitive.</p>
                     <div class="wv-divider"></div>
                     <div class="row-fluid">

                     <div class="py-1"> <strong>&nbsp Company Name: </strong>&nbspThe name of the company. If blank, it will default to the customer's first and last names.</div>
                    </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp First Name: </strong>&nbsp The first name of your customer.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Last Name: </strong>&nbsp The last name of your customer.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Email:</strong>&nbsp The email address of your customer.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Phone: </strong>&nbsp The customer's phone number.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Address 1: </strong>&nbsp The first line of the customer's address.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Address 2: </strong>&nbsp The second line of the customer's address.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp City: </strong>&nbsp The city the customer is in.</div>
                     </div>



                 </div>
                 </div>

             </div>
             </div>
             </div>
                 </div>
                <div v-else>
                    <div class="py-5">
                        <div class="text-center">
                        <div class="spinner-grow spinner-grow-xl" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div v-if="!errorOnUpload">
                            <h3>Importing contacts</h3>
                            <p class="py-1">Do not close this page once done uploading the page will refresh!</p>
                        </div>
                        <div v-else>
                            <h3 class="text-danger">An error occuered while importing contacts</h3>
                            <p>Please check if your file follows our format <a data-toggle="collapse" href="#collapseCustomer" role="button" aria-expanded="false" aria-controls="collapseCustomer">
                                outlined here</a> </p>
             <div class="collapse" id="collapseCustomer">
             <div class="card card-body">
                 <div class="text-left">
                 <h2 class="wv-heading--subtitle">Customer CSV template file</h2>
                 <p ><a class="wv-text--link" href="https://dukakit-r2-bucket.dukakit.com/Dukakit_Customer_Import_List_Template%20-%20Sheet1.csv">Download and view our customer CSV template.</a> You can use this as a template for creating your CSV file.</p>

                <hr/>

                 <h2 class="wv-heading--subtitle">File format</h2>
                 <p >The first line of your customer CSV <strong>&nbsp must include all of the headers</strong>&nbsp  listed below, which are included in the <a class="wv-text--link" href="https://dukakit-r2-bucket.dukakit.com/Dukakit_Customer_Import_List_Template%20-%20Sheet1.csv">customer CSV template</a>.</p>
                 <div class="wv-box wv-box--large wv-box--gray">
                 <div class="text-left">
                     <p ><i class="wv-icon--info"></i> <strong>&nbsp Reminder: </strong>&nbsp  All CSV file headers are case-sensitive.</p>
                     <div class="wv-divider"></div>
                     <div class="row-fluid">

                     <div class="py-1"> <strong>&nbsp Company Name: </strong>&nbspThe name of the company. If blank, it will default to the customer's first and last names.</div>
                    </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp First Name: </strong>&nbsp The first name of your customer.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Last Name: </strong>&nbsp The last name of your customer.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Email:</strong>&nbsp The email address of your customer.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Phone: </strong>&nbsp The customer's phone number.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Address 1: </strong>&nbsp The first line of the customer's address.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp Address 2: </strong>&nbsp The second line of the customer's address.</div>
                     </div>

                     <div class="row-fluid">
                     <div class="py-1"><strong>&nbsp City: </strong>&nbsp The city the customer is in.</div>
                     </div>



                 </div>
                 </div>

             </div>
             </div>
             </div>
                            <a class="btn btn-primary" href="/customers">Reload Page</a>
                        </div>


                        </div>

                    </div>
                </div>


            </b-modal>
        </div>
        <div  v-else>

                    <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading Inventory...</span>
                    </div>

                </div>

        </div>

    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import { mapGetters } from "vuex";
    export default {
        components: {
            vueDropzone: vue2Dropzone
        },
        name: 'customer',

        data() {
            return {
                customerstable: {
                    fields: [
                        "index",
                        {
                            key: "full_name",
                            sortable: true
                        },
                        {
                            key: "email",
                            sortable: true
                        },
                        {
                            key: "phone",
                            sortable: true
                        },
                        // {
                        //     key: "last_visit",
                        //     sortable: true
                        // },
                        {
                            key: "created_at",
                            sortable: true,
                            label:"Date Joined",
                        },
                        // {
                        //     key: "last_amount",
                        //     sortable: true
                        // },
                    ],
                    items: [],
                },
                currentPage: 1, // Current page
                perPage: 10, // Items per page
                totalCustomers: 0, // Total records (from API)
                orderstable: {
                    fields: [
                        "index",
                        {
                            key: "order",
                            sortable: true
                        },
                        {
                            key: "amount",
                            sortable: true
                        },
                        {
                            key: "date_",
                            sortable: true
                        },
                    ],
                    items: []
                },
                smsForm: {
                    message: ''
                },
                errorOnUpload:'',
                customerData:{
                    town: '',
                    street: '',
                    apartment: '',
                    h_no: '',
                    phone_no: '',
                    c_email: '',
                    l_name: '',
                    f_name: '',
                    id: '',
                },


                //custom
                successMessage: '',
                Allcustomers: '',
                searchCustomerQuery: '',
                customer_data: '',
                searchCustomer: '',
                max_order: '',
                customer_orders: '',
                last_visit: '',
                dropzoneOptionsCustomer: {
                    url: "/api/files",
                    addRemoveLinks: true,
                    maxFiles: 5,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    acceptedFiles: ".xls,.xlsx,.csv"
                },
                customerFileProcessing:false,
                customerImportFileName:'',
                pageHasLoaded:false,
                searchTimeout: null, // For debouncing
            }
        },
        watch: {

            searchCustomerQuery() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.currentPage = 1; // Reset to first page on search
                this.getCustomers();
            }, 500); // Debounce delay (500ms)
        }
    },
        mounted() {
            this.getCustomers()
        },
        methods: {

        uploadFileSuccess(file, response) {
                this.$toasts.push({
                    type: 'success',
                    message: "File uploaded successfully",
                });
                this.customerFileProcessing=true
                this.customerImportFileName=response.file
                this.customerImportPath=response.path

              this.importContacts()
                console.log(response.file,file)

            },

            uploadError(file, message) {
                this.$toasts.push({
                    type: 'error',
                    message: "There was an error uploading your file",
                });
            },
            openTextboxModal() {
               this.$refs.textBoxModal.show()
            },
            fileRemoved(file) {
                // if (file.serverResponse) {
                //     this.bulkRestock.receiptFile = this.bulkRestock.receiptFile.filter(f => f !== file.serverResponse);
                // } else {
                //     // If no serverResponse, match using file name or other attributes
                //     const fileResponse = JSON.parse(file.xhr.response);
                //     const fileName = fileResponse.file;

                //     // Find the index of the file name in receiptFile array
                //     const index = this.bulkRestock.receiptFile.findIndex(f => f === fileName);

                //     if (index > -1) {
                //         // Remove the file from the array
                //         this.bulkRestock.receiptFile.splice(index, 1);
                //     }


                // }
            },
            async importContacts()
            {
                axios.post('/api/import-customers',{
                    file:this.customerImportFileName,
                    path:this.customerImportPath
                }).then(results=>{
                    if(results.status === 200)
                    {
                        window.location.reload()
                    }

                }).catch(err=>{

                    this.errorOnUpload = "Error"
                })
            },


            RowSelected(items) {
              window.location.href = `/customer?id=${items.id}`
            },
            sendSMSToCustomer() {
                axios.post('/api/send-sms-to-customer', {
                    customer: this.customer_data,
                    message: this.smsForm.message
                }).then(results => {
                    if (results.delivery === 'success') {
                        this.$toasts.push({
                            'type': "success",
                            "message": "Message sent successfully"
                        })
                    }
                    this.$refs.textmessage_modal.hide()
                })
            },
            sendSMSToAllCustomers() {
                axios.post('/api/send-sms-to-customer', {
                    all:true,
                    message: this.smsForm.message
                }).then(results => {

                    if (results.delivery === 'success') {
                        this.$toasts.push({
                            'type': "success",
                            "message": "Message sent successfully"
                        })
                    }
                    this.$refs.textmessage_modal.hide()
                })
            },
            getCustomers() {
                axios.get(
                    `/api/allcustomers?page=${this.currentPage}&per_page=${this.perPage}&search=${this.searchCustomerQuery}`
                )
                    .then(result => {
                        if(result.status === 200)
                    {

                        this.customerstable.items = result.data.data;
                        this.totalCustomers = result.data.total;
                        this.currentPage = result.data.current_page;
                        this.pageHasLoaded=true
                    }

                    });
            },

            formatDate(date,format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            },
            DeleteCustomer(customer_id) {
                axios.get('/api/customer_delete', {
                        params: {
                            customer_id
                        }
                    })
                    .then(result => {
                        this.$root.$toasts.push({
                            type: 'success',
                            message: "Customer data has been deleted",
                        });
                        this.$refs['customermodaldel'].hide();
                        this.getCustomers();
                    });
            },
            addNewCustomerModal() {
                this.$refs['new-customers-modal'].show();
            },
            NewCustomerInfo(e) {
                e.preventDefault();
                axios.post('/api/newcustomer', {
                       ...this.customerData
                    })
                    .then(result => {
                        this.$refs['new-customers-modal'].hide();
                        if(result.status === 200)
                        {
                            this.$root.$toasts.push({
                            type: result.data.type,
                            message: result.data.message,
                        });
                        // this.$refs['new-customers-modal'].hide();
                            this.getCustomers()
                        }

                    });
            },
            downloadCustomerFile() {
                axios({
                        method: 'get',
                        url: '/api/allcustomers',
                        responseType: 'blob',
                        params: {
                            export: true
                        }
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'customers.xlsx'); // Specify the filename
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(error => {
                        console.error('Error downloading file:', error);
                    });
            },
             hasPermission(permissionName) {
                 return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },

    },
    computed: {

         ...mapGetters(['userDetails']),
        filteredCustomerDetails() {
                    return this.customerstable.items.filter(item => {
                        const customerName = item.full_name ? item.full_name.toLowerCase() : '';
                        const phone = item.phone ? item.phone.toLowerCase() : '';
                        const email = item.email ? item.email.toLowerCase() : '';
                        return customerName.includes(this.searchCustomer.toLowerCase()) || phone.includes(this.searchCustomer.toLowerCase()) || email.includes(this.searchCustomer.toLowerCase());
                    });
            },
    },

    }
</script>
